/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import ActionCreator from '../action-creator';

export const ActionCreators = {
  RequestBeams: new ActionCreator<'RequestBeams', any>('RequestBeams'),
  ReceivedBeamsSuccess: new ActionCreator<'ReceivedBeamsSuccess', any>('ReceivedBeamsSuccess'),
  ReceivedBeamsError: new ActionCreator<'ReceivedBeamsError', any>('ReceivedBeamsError'),
  RequestFlHeatMaps: new ActionCreator<'RequestFlHeatMaps', any>('RequestFlHeatMaps'),
  ReceivedFlHeatMapsSuccess: new ActionCreator<'ReceivedFlHeatMapsSuccess', any>('ReceivedFlHeatMapsSuccess'),
  ReceivedFlHeatMapsError: new ActionCreator<'ReceivedFlHeatMapsError', any>('ReceivedFlHeatMapsError'),
  RequestRlHeatMaps: new ActionCreator<'RequestRlHeatMaps', any>('RequestRlHeatMaps'),
  ReceivedRlHeatMapsSuccess: new ActionCreator<'ReceivedRlHeatMapsSuccess', any>('ReceivedRlHeatMapsSuccess'),
  ReceivedRlHeatMapsError: new ActionCreator<'ReceivedRlHeatMapsError', any>('ReceivedRlHeatMapsError'),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function requestBeams(
  ...versions: string[]
) {
  return ActionCreators.RequestBeams.create( [ ...(versions.filter(version => version !== '')) ] );
}

export function requestFlHeatMaps(antennaTypeId: number, sscfFileVersion: string) {
  return ActionCreators.RequestFlHeatMaps.create({ antennaTypeId, sscfFileVersion });
}

export function requestRlHeatMaps(antennaTypeId: number, sscfFileVersion: string) {
  return ActionCreators.RequestRlHeatMaps.create({ antennaTypeId, sscfFileVersion });
}
